import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { usePost } from "seed/api";
import { AREAS, BASE_PROCESSES, AREA_PROCESSES } from "components/vmisc/onboarding/GetStarted.lib.catalogs";
import View from "components/vmisc/onboarding/GetStarted.view";


function buildProcessOptions(area) {
  const specific = AREA_PROCESSES[area] || [];
  const combined = [
    ...BASE_PROCESSES,
    ...specific,
    { value: "other", label: "Otro (especificar)" },
  ];
  const seen = new Set();
  return combined.filter((o) => (seen.has(o.value) ? false : (seen.add(o.value), true)));
}


function HomeOnboarding() {

  const history = useHistory();
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");

  const [area, setArea] = useState("");
  const [processes, setProcesses] = useState([]);
  const [otherProcess, setOtherProcess] = React.useState("");
  const [values, setValues] = useState({
    primaryColor: "#2065a5",
    accentColor: "#f0b000",
  });
  const [flowTemplate, setFlowTemplate] = useState(null);

  const [callStartSession, reqStartSession] = usePost("/users/start_anonymous_session", {
    onCompleted: (data) => {
      sessionStorage.setItem("token", data.token);
      sessionStorage.setItem("id", data.user);

      const flow = data?.flow;

      console.log("data", data)
      if (flow)
        history.push(`/app/${flow.token}`);
      else
      
        history.push("/app");
    },
    onError: (err) => {
      swal("Error", "Error al registrar los datos, por favor intente nuevamente mas tarde.", "error");
    }
  });

  useEffect(() => {
    setProcesses([]);
    setOtherProcess("");
  }, [area]);

  // useEffect(() => {
  //   const token = sessionStorage.getItem("token");
  //   const id = sessionStorage.getItem("id");

  //   if (token && id)
  //     history.push("/app");
  //   else
  //     sessionStorage.clear();
  // }, []);

  const processOptions = React.useMemo(() => buildProcessOptions(area), [area]);
  const totalSteps = 4;
  const percent = Math.round((step / totalSteps) * 100);

  const toggleProcess = (val) => {
    setProcesses((prev) =>
      prev.includes(val) ? prev.filter((v) => v !== val) : [...prev, val]
    );
  };

  const canNext = () => {
    if (step === 1) return area.trim().length > 0;
    if (step === 2) {
      if (processes.length === 0) return false;
      if (processes.includes("other")) return otherProcess.trim().length > 0;
      return true;
    }
    if (step === 3) return !!values.primaryColor && !!values.accentColor;
    if (step === 4) return !!flowTemplate;
    return true;
  };

  const next = () => setStep((s) => Math.min(totalSteps, s + 1));
  const back = () => setStep((s) => Math.max(1, s - 1));

  const finish = async () => {
    setError("");

    const formattedProcesses = processes.includes("other") ?
      [...processes.filter(p => p !== "other"), otherProcess] :
      processes;

    const payload = {
      area: area,
      processes: formattedProcesses,
      primary_color: values.primaryColor,
      accent_color: values.accentColor,
      template_flow: flowTemplate
    };
    callStartSession(payload);
  };

  const onSelectFlowTemplate = (flowId) => {
    setFlowTemplate(flowId);
  }

  const loading = reqStartSession.loading;

  return (
    <View
      step={step}
      values={values}
      back={back}
      next={next}
      finish={finish}
      processOptions={processOptions}
      otherProcess={otherProcess}
      totalSteps={totalSteps}
      area={area}
      processes={processes}
      percent={percent}
      loading={loading}
      error={error}
      toggleProcess={toggleProcess}
      setValues={setValues}
      setArea={setArea}
      canNext={canNext}
      onSelectFlowTemplate={onSelectFlowTemplate}
      setOtherProcess={setOtherProcess}
    />
  );
}

HomeOnboarding.propTypes = {};

export default HomeOnboarding;